import { createFileRoute } from "@tanstack/react-router"
import ForecastingReports from "~/pages/internal/forecasting-reports"

export const Route = createFileRoute("/_auth/internal/forecasts/forecasting-reports")({
  component: ForecastingReports,
})
